
import * as React from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { ICommand, ICommandStateProps } from '../../models/commands/ICommand';
import { CommandSet, ICommandSetStateProps } from '../commandSet/CommandSet';
import { LayoutGroup } from '@uifabric/experiments/lib/LayoutGroup';

export interface IActionCommandButtonStripProps {
  commands: ICommand[];
}

export class ActionCommandButtonStrip extends React.PureComponent<IActionCommandButtonStripProps> {
  public render(): JSX.Element {
    return (
      <CommandSet commands={ this.props.commands }>
        { ({ menuItems }: ICommandSetStateProps) => {
          return (
            <LayoutGroup direction='horizontal'>
              {
                menuItems.map((menuItem: IContextualMenuItem & ICommandStateProps) => {
                  const {
                    onClick: menuItemOnClick
                  } = menuItem;

                  const onClick = menuItemOnClick ? () => {
                    menuItemOnClick();
                  } : undefined;

                  return (
                    <DefaultButton key={ menuItem.key } onClick={ onClick }>{ menuItem.name }</DefaultButton>
                  );
                })
              }
            </LayoutGroup>
          );
        } }
      </CommandSet>
    );
  }
}
